import { lazy } from "react";
import { RouteConfig } from "../../../types/RouteConfig";

export const errorMembershipRoute: RouteConfig<'with-page'> = {
    name: 'Error - Membership',
    path: '/errors/Membership',
    page: lazy(() => import('.')),
    context: 'member'
}